export { default } from "./HeadingGrid";
export * from "./HeadingGrid";
export * from "./HeadingGrid.model";
